import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent implements OnInit {
  @Input() items: any[];
  @Input() numDisplayedItems = 2;

  @ContentChild(TemplateRef) template: TemplateRef<any>;

  startIndex = 0;
  endIndex = 0;
  dots: any;

  Math = Math;

  constructor() { }

  ngOnInit(): void {
    this.endIndex = Math.min(this.startIndex + this.numDisplayedItems, this.items.length);
    this.dots = [].constructor(Math.ceil(this.items.length / this.numDisplayedItems));
  }

  previous(): void {
    if (this.startIndex === 0) {
      return;
    }

    this.startIndex -= this.numDisplayedItems;
    this.endIndex = this.startIndex + this.numDisplayedItems;
  }

  next(): void {
    if (this.endIndex >= this.items.length) {
      return;
    }

    this.startIndex += this.numDisplayedItems;
    this.endIndex = this.startIndex + this.numDisplayedItems;
  }

  goTo(index: number): void {
    this.startIndex = index * this.numDisplayedItems;
    this.endIndex = this.startIndex + this.numDisplayedItems;
  }

}
